<template>
  <AffiliateLandingPage
    imageExt="svg"
    imageName="freeway"
    welcomeGroup="Freeway Customers"
    routePath="freeway"
  >
  </AffiliateLandingPage>
</template>

<script>
import AffiliateLandingPage from '@/components/Affiliate/AffiliateLandingPage.vue'

export default {
  components: {
    AffiliateLandingPage
  },
  name: 'FreewayLandingPage'
}
</script>

<style></style>
